// Setup the API v2 client
import { DealerKitClient } from "../../api-clients/ts";
const DealerKit = new DealerKitClient({
    basePath: window.marque.ui.apiUrl
});
export default DealerKit;
